import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { createResource, useResource } from '@/lib/i18n'
import LazyLoad from 'react-lazyload'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar } from 'swiper'
SwiperCore.use([Pagination, Scrollbar])

const resource = createResource({
  en: {
    title: 'Ongoing Promos',
  },
  id: {
    title: 'Promo Yang Sedang Berlangsung',
  },
})

interface IProps {
  promotionList: any
}

const Promotion = (props: IProps) => {
  const { promotionList } = props
  const { t } = useResource(resource)
  const promotionItem = [
    {
      link: 'https://www.kreditpintar.com/education/melangkah-ekstra-yakin',
      image: '/images/home/promo-banner-melangkah.png',
      mobile_image: '/images/home/promo-banner-melangkah-m.png',
    },
  ]
  const { width } = useWindowSize()

  const promotionListArray = promotionList?.banner
    ? Object.keys(promotionList.banner)
        .sort()
        .filter(
          (key) =>
            promotionList.banner[key].image && promotionList.banner[key].mobile_image && promotionList.banner[key].link,
        )
        .map((key) => ({
          image: promotionList.banner[key].image,
          mobile_image: promotionList.banner[key].mobile_image,
          link: promotionList.banner[key].link,
        }))
    : []

  const items = promotionListArray.length > 0 ? promotionListArray : promotionItem

  return (
    <Wrapper>
      <h2 className="title">{t('title')}</h2>
      <div className="container">
        <Swiper
          loop={items.length > 1}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          autoplay={items.length > 1 ? { delay: 3000, disableOnInteraction: false } : false}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <Link href={item.link}>
                <a target="_blank">
                  <LazyLoad>
                    <img className="banner" src={width > 1000 ? item.image : item.mobile_image} alt="promo-banner" />
                  </LazyLoad>
                </a>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Wrapper>
  )
}
export default Promotion

const Wrapper = styled.div`
  padding: 104px 150px 0px;
  text-align: center;
  max-width: 1440px;
  margin: 0 auto;

  .title {
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    font-size: 36px;
    line-height: 48px;
    margin-bottom: 48px;
  }
  .container {
    margin: 0 auto;
    .banner {
      width: 100%;
      border-radius: 8px;
      border: 1px solid #e6eaf0;
      cursor: pointer;
    }
  }

  @media only screen and (max-width: 1000px) {
    padding: 0;
    margin: 64px 20px 0 20px;
    text-align: center;
    max-width: 1440px;
    .title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 32px;
    }
  }
`
